import { create } from 'zustand'

type MobileTopNavStore = {
    hasMobileTopNav: boolean
    showMobileTopNav: boolean
    setHasMobileTopNav: (value: boolean) => void
    setShowMobileTopNav: (value: boolean) => void
}

export const useMobileTopNavStore = create<MobileTopNavStore>((set) => ({
    hasMobileTopNav: false,
    showMobileTopNav: false,
    setHasMobileTopNav: (value) => set({ hasMobileTopNav: value }),
    setShowMobileTopNav: (value) => set({ showMobileTopNav: value }),
}))
